export default {
  signals: 'Signals',
  axes: 'Axes',
  addAxis: 'Add axis',
};
